import { ContractStatus } from '@atomica.co/irori';
import { Labels } from '../models/common-model';

export const CONTRACT_STATUS_LABELS: Labels = {
  [ContractStatus.VALID]: '有効',
  [ContractStatus.INVALID]: '無効'
};
